/**
 * 薪酬路由
 */
export default [

  {
    path: '/wage/salaryItemDetail',
    name: '模板薪资项',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/set/salaryTemplate/salaryItem-detail.vue`),
    meta: {
      permission: ['hr_wage_new_set']
    }
  },
  {
    path: '/onetime-upload',
    name: '一次性导入',
    component: () => import ( /* webpackChunkName: "form" */ `@/components/ciic/onetime-upload/batchParent`),
    meta: {
      permission: ['hr_wage__new_data_ready']
    }
  },
  {
    path: '/wage/data-ready-template',
    name:'数据准备',
    meta: {
      keepAlive: true,
      permission: ['hr_wage__new_data_ready']
    },
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/dataReadyTemplate/dataImport/dataImport.vue`),
  },
  {
    path: '/wage/paymentWage',
    name:'工资发放',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/pay/paymentWage.vue`),
    meta: {
      permission: ['hr_wage_new_pay']
    }
  },
  {
    path: '/wage/wageHistory',
    name:'工资历史',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/batch/his/wageHistory.vue`),
    meta: {
      permission: ['hr_wage_new_his']
    }
  },
  {
    path: '/wage/salaryApproval',
    name:'工资审批',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/approve/approval.vue`),
    meta: {
      permission: ['hr_wage_new_approve']
    }
  },
  {
    path: '/payrollSettings/payOutUnderGroupTable',
    name:'线下发薪明细页',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/pay/payOutUnderGroupTable.vue`),
    meta: {
      permission: ['hr_wage_new_pay']
    }
  },
  {
    path: '/payrollSettings/wageBatchInfoGroupTable',
    name:'单工资条明细页',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/batch/onlyWage/wageBatchInfoGroupTable.vue`),
    meta: {
      permission: ['hr_wage_new_pay','hr_wage_new_his','hr_wage_new_only_wage']
    }
  },
  {
    path: '/payrollSettings/onePayHistory',
    name: '单工资条',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/batch/onlyWage/onlyWageHistory.vue`),
    meta: {
      permission: ['hr_wage_new_only_wage']
    }
  },
  {
    path: '/wage/attachmentManage',
    name:'附件管理',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/attachmentManage/attachmentList.vue`),
    meta: {
      permission: ['hr_wage_new_pay','hr_wage_new_his','hr_wage_new_only_wage']
    }

  },
  {
    path: '/wage/salaryTax',
    name:'个税申报',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/salaryTax/salaryTaxList.vue`),
    meta: {
      permission: ['hr_wage_new_tax']
    }

  },
  {
    path: '/wage/wagesDetailList',
    name:'工资明细',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/salaryTax/wagesDetailList.vue`),
    meta: {
      permission: ['hr_wage_new_pay','hr_wage_new_his','hr_wage_new_only_wage']
    }
  },
  {
    path: '/wage/taxDetailList',
    name:'税金明细',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/salaryTax/taxDetailList.vue`),
    meta: {
      permission: ['hr_wage_new_tax']
    }
  },
  {
    path: '/wage/payment/pay-notice/emp-wage-detail',
    name: '付款通知单明细数据',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/pay-notice/wageDetailList.vue`),
    meta: {
      permission: ['set_paymentnotice_approve']
    }
  },
  {
    path: '/wage/paymentApproval',
    name: '付款通知单审批设置',
    component: () => import ( /* webpackChunkName: "apvlProPayAdvSet" */ `@/views/wage/apvlPrc/paymentAdviceSet/index.vue`),
    meta: {
      permission: ['set_paymentnoticesetting_approve']
    }
  },




  {
    path: '/wage/refundTabs',
      name: '退票',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/refund/refundTabs.vue`),
    meta: {
      permission: ['set_refundtitcket']
    }
  },
  {
    path: '/wage/salarySet',
    name: '薪酬设置',
    component: () => import ( /* webpackChunkName: "salarySet" */ `@/views/wage/set/salarySet.vue`),
    meta: {
      permission: ['hr_wage_new_set']
    },
    children:[
      {
        path: '/',
        name: '公司设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/set/companyTemplate/companyInfo.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },
      {
        path: '/wageSet/step1',
        name: '公司设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/set/companyTemplate/companyInfo.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },
      {
        path: '/wageSet/step2',
        name: '薪酬组',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/set/payGroupSetting/payGroup-list.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },
      {
        path: '/wage/payGroupDetail',
        name: '薪酬组明细',
        component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/set/payGroupSetting/payGroup-detail.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },
      {
        path: '/wageSet/step3',
        name: '工资模板',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/set/salaryTemplate/salaryTemplate-list.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },
      {
        path: '/wageSet/step4',
        name: '审批流程',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step4.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },
      {
        path: '/wageSet/step5',
        name: '工资单',
        component: () => import ( /* webpackChunkName: "step2" */  `@/views/wage/set/salaryTemplate/payrollSetting.vue`),
        meta: {
          permission: ['hr_wage_new_set']
        }
      },

    ]
  },
  {
    path: '/wage/salaryDetailTabs',
    name: '薪资明细',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/dataReadyTemplate/salary-detail-tabs.vue`),
    meta: {
      permission: ['hr_wage__new_data_ready','hr_wage_new_pay','hr_wage_new_his','hr_wage_new_only_wage']
    }
  },
  {
    path: '/hrms/wage/wageCalculate.do',
      name: '薪资正算',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['wage_forward_calculate']
    }
  },
  {
    path: '/hrms/wage/wageUnCalculate.do',
      name: '薪资倒算',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['wage_reverse_calculate']
    }
  },
  {
    path: '/payslip/detail',
      name:'打包下载工资单',
    component: () => import ( `@/views/wage/payslip/detail.vue`),
    meta: {
      permission: ['set_payed_paysilp']
    }
  },
  {
    path: '/payslip/ziptask',
      name: '打包下载工资单任务',
    component: () => import ( `@/views/wage/payslip/PayslipZipTask.vue`),
    meta: {
      permission: ['set_payed_paysilp']
    }
  },
  {
    path: '/payslip/unpaybatchinfo',
      name: '发放中批次信息表',
    component: () => import ( `@/views/wage/payslip/unpayBatchInfo.vue`),
    meta: {
      permission: ['set_unpay_paysilp_batch']
    }
  },
  {
    path: '/payslip/unpayslippreview',
      name: '发放中工资单预览',
    component: () => import ( `@/views/wage/payslip/unpayDetail.vue`),
    meta: {
      permission: ['set_unpay_paysilp_batch']
    }
  },
  {
    path: '/incomeProof/detail',
      name:'收入证明开具',
    component: () => import ( `@/views/wage/incomeProof/detail.vue`),
  },
  {
    path: '/merit/batch',
    name: '绩效管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/ruichen/meritManagement.vue`),
    meta: {
      permission: ['set_merit_management']
    }
  },
  {
    path: '/merit/debtDetails',
    name: '绩效详情',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/ruichen/meritDetails.vue`),
    meta: {
      permission: ['set_merit_management']
    }
  },
  {
    path: '/merit/debtDetailsForHR',
    name: '绩效详情汇总',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/ruichen/meritDetailsForHR.vue`),
    meta: {
      permission: ['set_merit_management_hr']
    }
  },

  {
    path: '/seagate/seagate-file',
    name: '希捷文件下载',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/seagate/fileDownload.vue`),
    meta: {
      permission: ['hr_seagate_fileDownload']
    }
  },

  {
    path: '/seagate/finance-report',
    name: '希捷财务报表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/seagate/financeReport.vue`),
    meta: {
      permission: ['hr_seagate_financeReport']
    }
  }
]
